var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-diff-change",class:[
    ("type-" + (_vm.change.type))
  ]},[_c('div',{staticClass:"lines"},[_c('div',{staticClass:"ln ln1"},[_vm._v(" "+_vm._s(_vm.ln1)+" ")]),_c('div',{staticClass:"ln ln2",class:{
        disabled: !_vm.ln2
      },on:{"click":function($event){return _vm.openInEditor()}}},[_vm._v(" "+_vm._s(_vm.ln2)+" ")])]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.change.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }